import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import {
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullId
} from '@/types'
import { BibliographySetDetailVolume } from '@/api'

export interface ModalBibliographyDetailSetStoreInterface {
  bibliographySetId: number
  disabledSelect?: boolean
  isBibliographySelectProcess?: boolean
  tabType: BibliographyDetailSetTabType
  onBackCondition?: () => void
  onBackResult?: () => void
  onSelect?: (obj: {
    bibliographyFullId: BibliographyFullId
    selectedBibliographyRealId: number
  }) => void
  onToggleReal?: (
    bibliographyId: number,
    tabType: BibliographyDetailRealTabType
  ) => void
}

@Module({
  name: 'ModalBibliographyDetailSetStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographyDetailSetStore extends BaseStore {
  _isOpen: boolean = false

  _disabledSelect: boolean = false

  // 書誌・巻号のペジネーション用に準備を行う
  _volumes: BibliographySetDetailVolume[] = []

  _isBibliographySelectProcess: boolean = false

  _bibliographySetId: number = 0

  _tabType: BibliographyDetailSetTabType = BibliographyDetailSetTabType.Volume

  _backConditionCallback?: () => void

  _backResultCallback?: () => void

  _selectCallback?: (obj: {
    bibliographyFullId: BibliographyFullId
    selectedBibliographyRealId: number
  }) => void

  _toggleRealCallback?: (
    bibliographyId: number,
    tabType: BibliographyDetailRealTabType
  ) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get disabledSelect(): boolean {
    return this._disabledSelect
  }

  get volumes(): BibliographySetDetailVolume[] {
    return this._volumes
  }

  get isBibliographySelectProcess(): boolean {
    return this._isBibliographySelectProcess
  }

  get bibliographySetId(): number {
    return this._bibliographySetId
  }

  get tabType(): BibliographyDetailSetTabType {
    return this._tabType
  }

  @Mutation
  public open(params?: ModalBibliographyDetailSetStoreInterface) {
    this._isOpen = true
    if (params) {
      this._disabledSelect = params.disabledSelect ?? false
      this._isBibliographySelectProcess =
        params.isBibliographySelectProcess ?? false
      this._bibliographySetId = params.bibliographySetId
      this._tabType = params.tabType
      this._backConditionCallback = params.onBackCondition
      this._backResultCallback = params.onBackResult
      this._selectCallback = params.onSelect
      this._toggleRealCallback = params.onToggleReal
    }
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public setVolumes(value: BibliographySetDetailVolume[]) {
    this._volumes = value
  }

  @Mutation
  public backCondition() {
    if (this._backConditionCallback) {
      this._backConditionCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public backResult() {
    if (this._backResultCallback) {
      this._backResultCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public select(obj: {
    bibliographyFullId: BibliographyFullId
    selectedBibliographyRealId: number
  }) {
    if (this._selectCallback) {
      this._selectCallback(obj)
    }

    // 選択後、エラーが発生した場合、ダイアログ表示を閉じたくないのでこの時点ではfalseを設定しない
  }

  @Mutation
  public toggleReal(value: {
    bibliographyId: number
    tabType: BibliographyDetailRealTabType
  }) {
    if (this._toggleRealCallback) {
      this._toggleRealCallback(value.bibliographyId, value.tabType)
    }

    this._isOpen = false
  }
}
